import React, { useContext } from 'react';
import { SideNavigation, TopButton } from '../components';
import { SideNavContext } from '../contexts';
import Header from '../components/header/Header';
import BusinessDetail from '../components/businessDetail/BusinessDetail';

const Business = () => {

    const { isSideNavOpen } = useContext(SideNavContext);

    return (
        <>
            {isSideNavOpen && <SideNavigation />}

            <Header />

            <main>
                <BusinessDetail />
            </main>

            <TopButton />
        </>
    );
};

export default Business;